import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (n) => new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(n || 0);

export const AdminFunnel = () => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        axios.get(`${API}/admin/conversion-stats`).then((r) => setStats(r.data)).catch(() => {});
    }, []);

    if (!stats) return null;
    const max = Math.max(1, ...stats.steps.map((s) => s.count));

    return (
        <div data-testid="admin-funnel" className="lux-card p-6 mb-12">
            <div className="flex justify-between items-baseline flex-wrap gap-2 mb-5">
                <div className="tracking-luxe text-[#B89C6A]">Entonnoir de conversion</div>
                <div className="text-[13px] text-[#1C1E1D]/60">
                    Encaissé : <span className="font-serif-lux text-xl text-[#B89C6A]">{fmt(stats.revenue_eur)} €</span>
                </div>
            </div>
            <div className="space-y-2.5">
                {stats.steps.map((s, i) => {
                    const prev = i > 0 ? stats.steps[i - 1].count : null;
                    const rate = prev ? Math.round((s.count / Math.max(1, prev)) * 100) : null;
                    return (
                        <div key={s.key} data-testid={`funnel-step-${s.key}`} className="flex items-center gap-4">
                            <div className="w-44 shrink-0 text-[11px] tracking-wider uppercase text-[#1C1E1D]/60">{s.label}</div>
                            <div className="flex-1 h-7 bg-[#1C1E1D]/5 relative overflow-hidden">
                                <div
                                    className="h-full bg-gradient-to-r from-[#B89C6A] to-[#B89C6A]/60 transition-all duration-700"
                                    style={{ width: `${Math.max(2, (s.count / max) * 100)}%` }}
                                />
                                <span className="absolute inset-y-0 left-3 flex items-center font-serif-lux text-[15px]">
                                    {s.count}
                                </span>
                            </div>
                            <div className="w-16 shrink-0 text-right text-[11px] text-[#B89C6A]">
                                {rate !== null ? `${rate} %` : ""}
                            </div>
                        </div>
                    );
                })}
            </div>
            <p className="mt-4 text-[10px] italic text-[#1C1E1D]/40">
                % = taux de passage depuis l'étape précédente · Estimations = estimations envoyées par email + demandes du simulateur
            </p>
        </div>
    );
};
